import { render, staticRenderFns } from "./AsignarPostulante.vue?vue&type=template&id=f06da1f4&scoped=true&"
import script from "./AsignarPostulante.vue?vue&type=script&lang=js&"
export * from "./AsignarPostulante.vue?vue&type=script&lang=js&"
import style0 from "./AsignarPostulante.vue?vue&type=style&index=0&id=f06da1f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06da1f4",
  null
  
)

export default component.exports